<template>
    <div class="wrap">
        <div class="proBox">
            <div class="proPic1"></div>
            <div class="proPic2">
                <div class="textbox1">
                    <!-- <ul>
                        <li><span>1、</span><label>使用本公司網站的客戶，請留意閣下所在的國家或居住地的相關法律規定，如有疑問應就相關問題，尋求當地法律意見。</label></li>
                        <li><span>2、</span><label>若發生遭駭客入侵破壞行為或不可抗拒之災害導致網站故障或資料損壞、資料丟失等情況，我們將以本公司之後備資料為最後處理依據；為確保各方利益，請各會員投注後列印資料。本公司不會接受沒有列印資料的投訴。</label></li>
                        <li><span>3、</span><label>為避免糾紛，各會員在投注之後，務必進入下注狀況檢查及列印資料。若發現任何異常，請立即與代理商聯繫查證，一切投注將以本公司資料庫的資料為准，不得異議。如出现特殊网络情况或线路不稳定导致不能下注或下注失败。本公司概不负责。</label></li>
                        <li><span>4、</span><label>單一注單最高派彩上限為一百萬。</label></li>
                        <li><span>5、</span><label>開獎結果以官方公佈的結果為准。</label></li>
                        <li><span>6、</span><label>我們將竭力提供準確而可靠的開獎統計等資料，但並不保證資料絕對無誤，統計資料只供參考，並非是對客戶行為的指引，本公司也不接受關於統計數據產生錯誤而引起的相關投訴。</label></li>
                        <li><span>7、</span><label>本公司擁有一切判決及註消任何涉嫌以非正常方式下註之權利，在進行更深入調查期間將停止發放與其有關之任何彩金。客戶有責任確保自己的帳戶及密碼保密，如果客戶懷疑自己的資料被盜用，應立即通知本公司，並須更改其個人詳細資料。所有被盜用帳號之損失將由客戶自行負責。在某種特殊情況下，客人之信用額可能會出現透支。</label></li>
                        <li style="text-align:right;">“{{title}}”管理層 敬啟　</li>
                    </ul> -->
                    <ul>
                        <li style="margin-bottom: 0px">
                        <span>1、</span>
                        <label>使用本公司网站站的客户，请留意阁下所在的国家或居住地的相关法律规定，如有疑问应就相关問題，寻求当地法律意见。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>2、</span>
                        <label>若发生遭骇客入侵破坏行为或不可抗拒之灾害导致网站故障或资料损坏、资料丟失等情況，我們将以本公司之后备资料为最后处理依据；为确保各方利益，请各会员投注后列印资料。本公司不会接受沒有列印资料的投诉。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>3、</span>
                        <label>为避免纠纷，各会员在投注之后，务必进入下注状況检查及列印资料。若发现任何异常，请立即与代理商联系查证，一切投注将以本公司资料库的资料为准，不得异议。如出现特殊网络情况或线路不稳定导致不能下注或下注失败。本公司概不负责。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>4、</span>
                        <label>开奖结果以官方公布的结果为准,如官方开奖延迟或开奖结果更改的，本公司有权进行更正处理，不得异议。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>5、</span>
                        <label>任何的投诉必须在开奖之前提出，本公司不会受理任何开奖之后的投诉。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>6、</span>
                        <label>所有投注项目，公布赔率时出现的任何打字错误或非故意人为失误，本公司保留改正错误和按正确赔率结算投注的权力。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>7、</span>
                        <label>开奖后的投注，将被视为“ 无效 ”。所有赔率将不定时浮动，派彩时的赔率将以确认投注时之赔率为准。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>8、</span>
                        <label>如发生临时性、突发性等特殊情况,本公司有权作出相对应之决定,不得异议。</label>
                        </li>
                        <li style="margin-bottom: 0px">
                        <span>9、</span>
                        <label>本公司所有投注皆含本金,请认真了解协议说明。您在本公司網站下第一笔注单时，就代表您已同意及接受所有本公司的《用户协议》。</label>
                        </li>

                        <li style="text-align:right;">“{{title}}”管理層 敬启</li>
                    </ul>
                </div>
                <div class="clear"></div>
            </div>
            <div class="proPic3">
                <input type="button" value="不同意" class="btn1 grayBtn" @click="exit()" >
                <input type="button" value="同意" class="btn1 hotBtn" @click="sure()"></div>
        </div>
    </div>
</template>

<script>
import getData from "../getData/getData";
export default {
    data(){
        return{
            title: sessionStorage.getItem('title')
        }
    },
    mounted(){
        document.title = "用户协议与规则";
        

        if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
            var i = document.createElement('iframe');
            // i.src = '/favicon.ico';
            i.style.display = 'none';
            i.onload = function() {
                setTimeout(function(){
                    i.remove();
                }, 9)
            }
            document.body.appendChild(i);
        }


        let data = {};
        data.access_token = window.sessionStorage
            .getItem("login")
            .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        getData.postAxiosMethod("userinfo", data, res => {
            if (res.data.data.skin == 0) {
               $('body').addClass('bg_0')
            } else if (res.data.data.skin == 2) {
                $('body').addClass('bg_2')
            } else if (res.data.data.skin == 1) {
                $('body').addClass('bg_1')
            } else {
                $('body').addClass('bg_3')
            }
        });
    },
    methods: {
        sure(){
            this.$emit('sure')
        },
        exit(){
            this.$emit('exit')
        }
    },
}
</script>

<style >
.bg_0{
    background-image:url(../../assets/images/userAgreement/LoginBg_0.jpg) !important;
    background-color:#894012 !important;
    background-repeat:no-repeat !important;
    background-size: 100% 100% !important;
}
.bg_1{
    background-image:url(../../assets/images/userAgreement/LoginBg_1.jpg) !important;
    background-color:#0f689d !important;
    background-repeat:no-repeat !important;
    background-size: 100% 100% !important;
}
.bg_2{
    background-image:url(../../assets/images/userAgreement/LoginBg_2.jpg) !important;
    background-color:#8d1b28 !important;
    background-repeat:no-repeat !important;
    background-size: 100% 100% !important;
}
.bg_3{
    background-image:url(../../assets/images/userAgreement/LoginBg_3.jpg) !important;
    background-color:#84b71a  !important;
    background-repeat:no-repeat !important;
    background-size: 100% 100% !important;
}
</style>

<style scoped>
html, body{height: 100%;}
/* body { font-family:"Microsoft YaHei";padding:0; margin:0;} */
body { font-family:"Microsoft YaHei";padding:0; margin:0;}
/* a {blr:expression(this.onFocus=this.blur()); border:none;} */
a:focus{ outline:0; }
.wrap{
	width: 547px;
	margin: 0 auto;
	padding-top: 6%;
}
/*用户协议*/
.proBox{width:547px; margin:0 auto; border-radius:8px;-webkit-border-radius:8px;-moz-border-radius:8px; }
.proPic1,.proPic2,.proPic3{ width:547px;background-repeat:no-repeat; float:left; }
.proPic1{ height:84px; border-radius:8px 8px 0 0;-webkit-border-radius:8px 8px 0 0;-moz-border-radius:8px 8px 0 0; border-bottom:none;}
.proPic2{ height:411px;  border-top:none; border-bottom:none;}
.proPic2 .textbox1{ width:501px; padding:0 23px; float:left;font-family:"宋体";}
.proPic2 .textbox1 ul{ width:500px;float:left; padding:0; margin:0;}
.proPic2 .textbox1 li{ width:500px; line-height:21px;margin-bottom:8px; float:left; color:#343434; list-style:none; font-size:12px; }
.proPic2 .textbox1 span{ width:20px; float:left;}
.proPic2 .textbox1 label{ width:480px; float:left;}
.proPic3{ height:53px; border-radius: 0 0 8px 8px;-webkit-border-radius: 0 0 8px 8px;-moz-border-radius: 0 0 8px 8px;border-top:none; text-align:center;}


.bg_0 .proBox {
    -webkit-box-shadow:0px 0px 13px #894012;
    -moz-box-shadow: 0px 0px 13px #894012;
    box-shadow: 0px 0px 13px #894012;
}
.bg_0 .proPic1,.bg_0 .proPic2,.bg_0 .proPic3{
    border:3px solid #894012;
}
.bg_0 .proPic1 {
    background:url(../../assets/images/userAgreement/pro1_0.png);
    border-bottom: none;
}
.bg_0 .proPic2 {
    background:url(../../assets/images/userAgreement/pro2_0.png);
    border-bottom: none;
    border-top: none;
}
.bg_0 .proPic3 {
    background:url(../../assets/images/userAgreement/pro3_0.png);
    border-top: none;
}

.bg_1 .proBox {
    -webkit-box-shadow:0px 0px 13px #0f689d;
    -moz-box-shadow: 0px 0px 13px #0f689d;
    box-shadow: 0px 0px 13px #0f689d;
}
.bg_1 .proPic1,.bg_1 .proPic2,.bg_1 .proPic3{
    border:3px solid #0f689d;
}
.bg_1 .proPic1 {
    background:url(../../assets/images/userAgreement/pro1_1.png);
    border-bottom: none;
}
.bg_1 .proPic2 {
    background:url(../../assets/images/userAgreement/pro2_1.png);
    border-bottom: none;
    border-top: none;
}
.bg_1 .proPic3 {
    background:url(../../assets/images/userAgreement/pro3_1.png);
    border-top: none;
}

.bg_2 .proBox {
    -webkit-box-shadow:0px 0px 13px #8d1b28;
    -moz-box-shadow: 0px 0px 13px #8d1b28;
    box-shadow: 0px 0px 13px #8d1b28;
}
.bg_2 .proPic1,.bg_2 .proPic2,.bg_2 .proPic3{
    border:3px solid #8d1b28;
}
.bg_2 .proPic1 {
    background:url(../../assets/images/userAgreement/pro1_2.png);
    border-bottom: none;
}
.bg_2 .proPic2 {
    background:url(../../assets/images/userAgreement/pro2_2.png);
    border-bottom: none;
    border-top: none;
}
.bg_2 .proPic3 {
    background:url(../../assets/images/userAgreement/pro3_2.png);
    border-top: none;
}

.bg_3 .proBox {
    -webkit-box-shadow:0px 0px 13px #84b71a ;
    -moz-box-shadow: 0px 0px 13px #84b71a ;
    box-shadow: 0px 0px 13px #84b71a ;
}
.bg_3 .proPic1,.bg_3 .proPic2,.bg_3 .proPic3{
    border:3px solid #84b71a ;
}
.bg_3 .proPic1 {
    background:url(../../assets/images/userAgreement/pro1_3.png);
    border-bottom: none;
}
.bg_3 .proPic2 {
    background:url(../../assets/images/userAgreement/pro2_3.png);
    border-bottom: none;
    border-top: none;
}
.bg_3 .proPic3 {
    background:url(../../assets/images/userAgreement/pro3_3.png);
    border-top: none;
}



.btn1{
	font-size: 12px;
	display: inline-block;
	border: none;
	-moz-border-radius: 3px;
	-webkit-border-radius: 3px;
	border-radius: 3px;
	cursor: pointer;
	width:80px;
	height:28px;
	line-height:26px;
	margin:18px 20px 0 20px;
}
.hotBtn{
	font-weight: bold;
	color: #fff;
	text-shadow: 0px 1px 0px #d05000;
	background: #f07700;
	background-image:-webkit-linear-gradient(to top, #e36600, #ff8800);
	background-image:linear-gradient(to top , #e36600, #ff8800);
	border-bottom: 1px solid #b74c00;
}
.hotBtn:hover{
	background: #ff8800;
	background-image:-webkit-linear-gradient(to top, #ff8800, #ff8800);
	background-image:linear-gradient(to top , #ff8800, #ff8800);
}
.grayBtn{
	font-weight: bold;
	color: #343434;
	text-shadow: 0px 1px 0px #b9c8df;
	background: #afc8e6;
	background-image:-webkit-linear-gradient(to top, #9dbbde, #bfd3ed);
	background-image:linear-gradient(to top , #9dbbde, #bfd3ed);
	border-bottom: 1px solid #6e96c8;
}
.grayBtn:hover{
	background: #bfd3ed;
	background-image:-webkit-linear-gradient(to top, #bfd3ed, #bfd3ed);
	background-image:linear-gradient(to top , #bfd3ed, #bfd3ed);
}

</style>